import type { z } from '@repo/schema'
import type { GetCompanyType } from '@repo/schema/company'

export type CompanyTypeAlias = z.infer<typeof GetCompanyType>['alias']

/** The company lists, by the type filter each requests from `GET /companies/:filter`. */
export const COMPANY_LIST_FILTERS = ['broker', 'haulier', 'other', 'shipper'] as const

export type CompanyListFilter = (typeof COMPANY_LIST_FILTERS)[number]

type CompanyType = string

const COMPANY_TYPE_LABELS = {
  broker: 'Broker',
  haulier: 'Carrier',
  other: 'Other',
  shipper: 'Customer',
} satisfies Record<CompanyTypeAlias, string>

export const getCompanyTypeLabel = (type: CompanyTypeAlias | null | undefined) =>
  type ? COMPANY_TYPE_LABELS[type] : COMPANY_TYPE_LABELS.other

export const isShipper = (companyType: CompanyType): boolean =>
  ['customer', 'customers', 'shipper', 'shippers'].includes(companyType)

export const isHaulier = (companyType: CompanyType): boolean =>
  ['carrier', 'carriers', 'haulier', 'hauliers'].includes(companyType)

export const isBroker = (companyType: CompanyType): boolean =>
  ['broker', 'brokers'].includes(companyType)

export const toRouteCompanyType = (
  type: 'broker' | 'carrier' | 'customer' | 'haulier' | 'other' | 'shipper' | null | undefined,
) => {
  switch (type) {
    case 'broker':
      return 'brokers'
    case 'carrier':
    case 'haulier':
      return 'carriers'
    case 'customer':
    case 'shipper':
      return 'customers'
    case 'other':
    default:
      return 'other-companies'
  }
}
